var map = {
	"./Rockvox_dry.wav": 119,
	"./Rockvox_wet.wav": 839,
	"./cappella_dry.wav": 608,
	"./cappella_wet.wav": 465,
	"./elettronic_dry.wav": 991,
	"./elettronic_wet.wav": 281,
	"./trapvox_dry.wav": 530,
	"./trapvox_wet.wav": 609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;